module.exports = __webpack_public_path__ + "static/media/google-play-badge.15083d03.jpg";